import axios from "axios";

const service = axios.create({
  baseURL: `${process.env.VUE_APP_TRACKING_SERVER_API_ENDPOINT}/v2`
});

export default service;
